<div class="crowdctrl-form-field" [class.crowdctrl-form-field--invalid]="invalid">
  <ng-content></ng-content>
  @if (hint) {
    <p class="crowdctrl-form-control-hint">{{ hint }}</p>
  }
</div>
